import React from "react";
import * as Icons from "lucide-react";
import { Check } from "lucide-react";
import { PARCOURS, JOIE, BLOCAGES } from "../../data/mockNormal";
import { useReveal } from "../../hooks/useReveal";

function ParcoursCard({ data, i }) {
  const ref = useReveal();
  return (
    <div ref={ref} className={`reveal reveal-delay-${i + 1} glass rounded-2xl p-7`}>
      <h4 className="text-2xl text-white mb-5">{data.title}</h4>
      <ul className="space-y-3">
        {data.items.map((it) => (
          <li key={it} className="flex items-start gap-3 text-white/80">
            <Check className="w-4 h-4 text-[#7fd8e8] mt-1 shrink-0" />
            <span className="text-[15px]">{it}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function BlocageCard({ b, i }) {
  const ref = useReveal();
  const Icon = Icons[b.icon] || Icons.Sparkles;
  return (
    <div ref={ref} className={`reveal reveal-delay-${(i % 4) + 1} glass card-lift rounded-2xl p-6`}>
      <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#e0464b]/25 to-[#5a5ee0]/20 flex items-center justify-center ring-1 ring-white/10 mb-4">
        <Icon className="w-5 h-5 text-[#ff8a8f]" />
      </div>
      <h4 className="text-xl text-white mb-2">{b.title}</h4>
      <p className="text-sm text-white/65 leading-relaxed">{b.text}</p>
    </div>
  );
}

export default function NormalExtra() {
  const parcHead = useReveal();
  const joieRef = useReveal();
  const blocHead = useReveal();
  return (
    <section className="relative py-24 md:py-28 ocean-bg">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div ref={parcHead} className="reveal text-center max-w-3xl mx-auto">
          <p className="eyebrow text-[#7fd8e8] text-xs mb-4">Le programme</p>
          <h2 className="text-4xl md:text-5xl text-white">Un parcours <span className="text-gold">en 14 fréquences</span></h2>
        </div>
        <div className="mt-12 grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <ParcoursCard data={PARCOURS.format} i={0} />
          <ParcoursCard data={PARCOURS.rythme} i={1} />
        </div>

        <div ref={joieRef} className="reveal mt-24 max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl text-white">{JOIE.title}</h2>
          <div className="mt-6 space-y-4 text-white/70 text-lg">
            {JOIE.paras.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>

        <div ref={blocHead} className="reveal mt-24 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl text-white">Les blocages que tu vas <span className="text-gold">dissoudre</span></h2>
        </div>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {BLOCAGES.map((b, i) => (
            <BlocageCard key={b.title} b={b} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
